// extracted by mini-css-extract-plugin
module.exports = {"contact-section":"Contact_contact-section__RsXhM","contact_buttons":"Contact_contact_buttons__2R_Lu"};